// styles
import styled from "styled-components";
import { mobile } from "../../../styles/responsive";
// types
import { FullReservation, ReservationPaymentList } from "../../../types/common.types";
import { useAdmin } from "../../../context/admin";
import removeTimezone from "../../../utils/removeTimezone";
import { BsEyeFill } from "react-icons/bs";
import { BiListUl } from "react-icons/bi";
import Checkbox from "../../common/Checkbox";
import formatNumberToString from "../../../utils/formatNumber";

function reduceReservations(reservations: FullReservation[]): FullReservation[] {
        const grouped: any = {};
        
        // Group by tour_id AND reservation_date
        reservations.forEach(reservation => {
            // Convert price and tickets to numbers for consistent calculation
            const price = Number(reservation.price) || 0;
            const tickets = Number(reservation.tickets) || 0;
            const tourId = reservation.tour_id;
            const date = reservation.reservation_date.split(/-/g).reverse().join('/'); // Extract date part only
            
            // Create a unique key combining tour_id and reservation_date
            const key = `${tourId}_${date}`;
            console.log(key)
            if (!grouped[key]) {
                grouped[key] = {
                    tour_id: tourId,
                    price: price,
                    tickets: tickets,
                    reservation_date: date
                };
            } else {
                // Sum the prices and tickets for same tour_id AND same date
                grouped[key].price += price;
                grouped[key].tickets += tickets;
            }
        });
        
        // Convert the grouped object back to array
        return Object.values(grouped);
    }

export default function List({data}: {data: ReservationPaymentList[]}) {
    const { setReservationData, setCreatePaymentResId, setViewPaymentsData, setCreatePaymentGroupId } = useAdmin()
    return (
        <Main>
            <TableWrapper>
                <Table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Seller / Ally</th>
                            <th>Type</th>
                            <th>Passenger</th>
                            <th>Order ID</th>
                            <th>Tour ID</th>
                            <th>Price</th>
                            <th>Tickets</th>
                            <th>Total reserva</th>
                            <th>Total pagado</th>
                            <th>Total a pagar</th>
                            <th style={{width: '60px'}}>View</th>
                            <th style={{width: '80px'}}>Payment</th>
                            <th style={{ width: '80px' }}>Confirmed Payment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((item, idx) => {
                                const group_passengers_base = item.type === 'group' ? item.reservations.map(r => r.passenger) : []
                                // prevent duplicated passengers in group reservations
                                const passengers = item.type === 'group' ? 
                                group_passengers_base.filter((passenger, index, self) =>
                                    index === self.findIndex((p) => (
                                        p.id === passenger.id
                                    ))
                                ) : [item.passenger]

                                const reservation_tours = item.type === 'group' ?
                                item?.reservations.filter((res, index, self) =>
                                    index === self.findIndex((r) => (
                                        r.tour_id === res.tour_id
                                    ))
                                ).map(r => r.tour_id) : [item.tour_id]

                                const price = item.type === 'group' ?
                                item.reservations.map(r => r.price).reduce((a,b) => a + b, 0)
                                : item.price
                                
                                const tickets = item.type === 'group' ?
                                item.reservations.map(r => r.tickets).reduce((a,b) => a + b, 0)
                                : item.tickets

                                const confirmedPayments = item.payments.filter(p => p.authorized).map(p => ((p.amount || 0) + (p.amount_tickets || 0))).reduce((a,b) => a + b, 0)
                                
                                const reducedReservations = () => {
                                    if (item!.type === 'group') {
                                        return reduceReservations(item!.reservations)
                                    } else return []
                                }
                                
                                let reservationsTotal = 0
                                if (item.type === 'individual') {
                                    reservationsTotal = item.price + item.tickets
                                } else
                                reservationsTotal = reducedReservations().map(r => Number(r.price) + Number(r.tickets)).reduce((a, b) => a + b, 0) 

                                const totalPaid = item.payments.map(p => Number(p.amount || 0) + Number( p.amount_tickets || 0)).reduce((a,b) => a + b, 0)
                                
                                return (
                                    <tr key={idx}>
                                        <td>{removeTimezone(item.reservation_date || item.reservations[0]?.reservation_date)}</td>
                                        <td>{passengers[0]?.seller?.name || passengers[0]?.ally?.name}</td>
                                        <td>{item.type}</td>
                                        <td>{passengers[0]?.name}</td>
                                        <td>{item.group_id || item.id}</td>
                                        <td>
                                            {reservation_tours.map((r, i) => (
                                                <span key={i}>
                                                    {r}
                                                    {i < reservation_tours.length - 1 && <br />}
                                                </span>
                                            ))}
                                        </td>
                                        <td>{price}</td>
                                        <td>{tickets}</td>
                                        <td>{formatNumberToString(reservationsTotal)}</td>
                                        <td>{formatNumberToString(totalPaid)}</td>
                                        <td>{formatNumberToString(reservationsTotal - totalPaid)}</td>
                                        <td>
                                            <button
                                                onClick={() => {
                                                    setReservationData(item)
                                                }}
                                                className="action-btn view-btn"
                                                title="View Details"
                                            >
                                                <BsEyeFill/>
                                            </button>
                                        </td>
                                        <td>
                                            <button 
                                                className="action-btn payment-btn"
                                                onClick={() => {
                                                    if (item.type === 'group') {
                                                        setCreatePaymentGroupId(item.group_id)
                                                    } else {
                                                        setCreatePaymentResId(item.id)
                                                    }
                                                    setViewPaymentsData(item.payments)
                                                }}
                                                title="Make Payment"
                                            >
                                                <BiListUl/>
                                            </button>
                                        </td>
                                        <td>
                                            <Checkbox
                                                checked={confirmedPayments >= (price + tickets)}
                                                containerStyle={{display: 'flex', justifyContent: 'center'}}
                                            />
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </TableWrapper>
        </Main>
    )
}

const Main = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 90%;
    margin: auto;
    margin-top: 15px;
    ${mobile({
        width: '100%',
        padding: '0 10px'
    })}
    
    overflow: unset;
    
    .sale {
        background-color: ${props => props.theme.whiteBackground};
        border-radius: 10px;
        box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
        cursor: pointer;
        transition: all .3s ease;
        
        &:hover {
            box-shadow: 0 5px 10px ${props => props.theme.blackTransparent};
            transform: translateY(-3px);
        }
        
        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 10px 10px 0 0;
            position: relative;
            height: 40px;
            background-color: ${props => props.theme.black};
            color: ${props => props.theme.white};
            
            .name {
                flex: 1;
                text-align: center;
            }
            
            .actions {
                height: 100%;
                display: flex;
                gap: 5px;
                padding: 5px;
                
                button {
                    height: 100%;
                    width: 50px;
                    font-size: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    color: ${props => props.theme.white};
                }
                
                button.traspax {
                    background-color: ${props => props.theme.blue};
                }
                
                button.details {
                    background-color: ${props => props.theme.yellowDark};
                }
                
                button.assign {
                    background-color: ${props => props.theme.lightGreen};
                }
            }
        }
    }
`

const TableWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: visible;
    
    ${mobile({
        overflowX: 'scroll',
        '-webkit-overflow-scrolling': 'touch'
    })}
`

const Table = styled.table`
    border-collapse: collapse;
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 1000px;
    
    ${mobile({
        minWidth: '800px'
    })}
    
    thead {
        width: 100%;
        background-color: #FFFFFF;
        position: sticky;
        top: 0;
        z-index: 10;
        
        tr {
            background-color: #f9fafb;
        }
        
        th {
            font-weight: 600;
            font-size: 13px;
            padding: 12px 8px;
            background-color: #f9fafb;
            border-bottom: 2px solid #e5e7eb;
            white-space: nowrap;
            text-align: center;
            color: #374151;
            
            ${mobile({
                fontSize: '12px',
                padding: '10px 6px'
            })}
        }
    }
    
    tbody {
        tr {
            transition: background-color 0.2s ease;
            
            &:hover {
                background-color: #f9fafb;
            }
        }
    }
    
    td {
        text-align: center;
        padding: 12px 8px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        white-space: nowrap;
        color: #1f2937;
        
        ${mobile({
            fontSize: '12px',
            padding: '10px 6px'
        })}
        
        .action-btn {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 16px;
            
            ${mobile({
                width: '28px',
                height: '28px',
                fontSize: '14px'
            })}
            
            &:hover {
                transform: scale(1.05);
            }
            
            &:active {
                transform: scale(0.95);
            }
        }
        
        .view-btn {
            background-color: #3b82f6;
            color: white;
            
            &:hover {
                background-color: #2563eb;
            }
        }
        
        .payment-btn {
            background-color: #10b981;
            color: white;
            
            &:hover {
                background-color: #059669;
            }
        }
        
        button.select {
            width: 20px;
            height: 20px;
            color: #000;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            background-color: ${props => props.theme.white};
            border: 1px solid ${props => props.theme.black};
            border-radius: 5px;
            cursor: pointer;
            transition: transform .3s ease;
            
            &:active {
                transform: scale(0.8);
            }
        }
        
        button.selected {
            background-color: ${props => props.theme.yellowDark};
        }
        
        button.info {
            border: none;
            background: none;
            font-size: 16px;
            cursor: pointer;
        }
        
        span {
            display: inline-block;
            line-height: 1.4;
        }
    }
    
    tr {
        height: auto;
        width: 100%;
    }
`